import wixWindow from 'wix-window';
import {test} from 'public/skip.js'

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
		$w("#bekol").show();
		$w("#milbat").show();
		$w("#migdalor").show();
	}
	//Desktop code
	
});

